import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { ShoppingCartComponent } from './shopping-cart/shopping-cart.component';
import { ProductFakeDetailsComponent } from './product-fake-details/product-fake-details.component';

const routes: Routes = [
  {
    path: '',
    component: ProductListComponent,
  },
 /*  {path: 'detalles/:code', component: ProductDetailsComponent }, */
  {path: ':provider/:code', component: ProductDetailsComponent },
  {path: 'cubatel/:code', component: ProductDetailsComponent },
  {path: 'amazon/:code', component: ProductDetailsComponent },
  //{path: 'amazon', component: ProductFakeDetailsComponent },
  //{path: 'cubatel', component: ProductFakeDetailsComponent },
  {path: 'carrito', component: ShoppingCartComponent } ,
  {path: '**', redirectTo: '', pathMatch: 'full'},
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductRoutingModule { }
